<template>
  <div>
    <!-- <v-row v-if="LastQuestion.type === 'quickReply'" class="mb-3">
      <v-col cols="12">
        <v-chip class="white--text" color="#0278ae" @click="AddAllButton"
          >เพิ่มเงื่อนไขจากปุ่มตัวเลือกทั้งหมด</v-chip
        >
      </v-col>
    </v-row> -->
    <v-alert
      class="elevation-2 rounded-lg"
      prominent
      v-for="(condition, i) in qrbtn"
      :key="`${i}_qr`"
      :color="condition.errorLabel ? 'red lighten-4' : ''"
    >
      <v-container>
        <v-row align="center">
          <v-col class="grow">
            <v-row align="center">
              <v-col cols="12" md="4" class="d-flex align-center">
                <span class="mr-3 mt-n3">{{ i + 1 }}.</span>
                <v-text-field
                  v-model="condition.fixtext"
                  label="เงื่อนไข"
                  dense
                  disabled
                  outlined
                  :error="condition.errorLabel"
                  :error-messages="condition.errorLabelMsg"
                  @input="CheckFixtextType(i)"
                  :rules="[$store.getters.TextRule(condition.fixtext)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="d-flex align-center">
                <v-text-field
                  v-model="condition.defaultCondition.score"
                  type="number"
                  solo
                  dense
                  label="คะแนน"
                  :disabled="condition.errorLabel"
                  :rules="[
                    $store.getters.ScoreRule(condition.defaultCondition.score),
                  ]"
                  style="width: 1px"
                >
                  <template #prepend> คะแนน </template>
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="d-flex align-center"
                v-if="!condition.hascompute"
              >
                <v-autocomplete
                  v-model="condition.defaultCondition.nextQuestionID"
                  :items="Jump"
                  label="เลือกคำถาม"
                  solo
                  dense
                  color="#0D8EEE"
                  item-text="questionLabel"
                  item-value="questionID"
                  :disabled="condition.errorLabel"
                  :rules="[
                    $store.getters.TextRule(
                      condition.defaultCondition.nextQuestionID
                    ),
                  ]"
                  :menu-props="{
                    closeOnClick: true,
                    closeOnContentClick: true,
                    maxHeight: 200,
                  }"
                >
                  <template #prepend> คำถามต่อไป </template>
                  <template v-slot:item="{ item }">
                    <v-list-item
                      @click="
                        condition.defaultCondition.nextQuestionID =
                          item.questionID
                      "
                      style="max-width: 400px"
                    >
                      <v-list-item-title>
                        <v-row no-gutters align="center">
                          <span class="d-flex align-center">
                            {{ item.questionLabel }}
                          </span>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <v-radio-group
                  v-model="condition.hascompute"
                  row
                  label="คำนวณคะแนน"
                  :disabled="condition.errorLabel"
                >
                  <v-radio label="มี" color="info" :value="true"></v-radio>
                  <v-radio label="ไม่มี" color="info" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="shrink d-flex align-center">
            <v-btn
              color="#DE4F3B"
              icon
              :style="{
                visibility: 'hidden',
              }"
              ><v-icon>mdi-trash-can-outline </v-icon></v-btn
            >
          </v-col>
        </v-row>
        <div v-if="condition.hascompute && !condition.errorLabel">
          <div>
            <ComputeScore
              :computeCondition="condition.computeCondition"
              :Jump="Jump"
              :NextQuestion="NextQuestion"
            />
          </div>
        </div>
      </v-container>
    </v-alert>
    <v-alert
      class="elevation-2 rounded-lg"
      prominent
      v-for="(condition, i) in fixtext"
      :key="i"
      :color="condition.errorLabel ? 'red lighten-4' : ''"
    >
      <v-container>
        <v-row align="center">
          <v-col class="grow">
            <v-row align="center">
              <v-col cols="12" md="4" class="d-flex align-center">
                <span class="mr-3 mt-n3">{{ qrbtn.length + (i + 1) }}.</span>
                <v-text-field
                  v-model="condition.fixtext"
                  label="เงื่อนไข"
                  dense
                  :error="condition.errorLabel"
                  :error-messages="condition.errorLabelMsg"
                  @input="CheckFixtextType(i)"
                  @keydown="SpaceNotAllow($event, condition.fixtext)"
                  @blur="TrimText(i)"
                  :rules="[$store.getters.TextRule(condition.fixtext)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="d-flex align-center">
                <v-text-field
                  v-model="condition.defaultCondition.score"
                  type="number"
                  solo
                  dense
                  label="คะแนน"
                  :disabled="condition.errorLabel"
                  :rules="[
                    $store.getters.ScoreRule(condition.defaultCondition.score),
                  ]"
                  style="width: 1px"
                >
                  <template #prepend> คะแนน </template>
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="d-flex align-center"
                v-if="!condition.hascompute"
              >
                <v-autocomplete
                  v-model="condition.defaultCondition.nextQuestionID"
                  :items="Jump"
                  label="เลือกคำถาม"
                  solo
                  dense
                  color="#0D8EEE"
                  item-text="questionLabel"
                  item-value="questionID"
                  :disabled="condition.errorLabel"
                  :rules="[
                    $store.getters.TextRule(
                      condition.defaultCondition.nextQuestionID
                    ),
                  ]"
                  :menu-props="{
                    closeOnClick: true,
                    closeOnContentClick: true,
                    maxHeight: 200,
                  }"
                >
                  <template #prepend> คำถามต่อไป </template>
                  <template v-slot:item="{ item }">
                    <v-list-item
                      @click="
                        condition.defaultCondition.nextQuestionID =
                          item.questionID
                      "
                      style="max-width: 400px"
                    >
                      <v-list-item-title>
                        <v-row no-gutters align="center">
                          <span class="d-flex align-center">
                            {{ item.questionLabel }}
                          </span>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <v-radio-group
                  v-model="condition.hascompute"
                  row
                  label="คำนวณคะแนน"
                  :disabled="condition.errorLabel"
                >
                  <v-radio label="มี" color="info" :value="true"></v-radio>
                  <v-radio label="ไม่มี" color="info" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="shrink d-flex align-center">
            <v-btn
              color="#DE4F3B"
              icon
              v-show="
                LastQuestion.type === 'quickReply'
                  ? true
                  : Object.keys(fixtext).length > 1
              "
              @click="$delete(fixtext, i), CheckFixtext()"
              ><v-icon>mdi-trash-can-outline </v-icon></v-btn
            >
          </v-col>
        </v-row>
        <div v-if="condition.hascompute && !condition.errorLabel">
          <div>
            <ComputeScore
              :computeCondition="condition.computeCondition"
              :Jump="Jump"
              :NextQuestion="NextQuestion"
            />
          </div>
        </div>
      </v-container>
    </v-alert>
    <v-row>
      <v-col cols="12" class="d-flex justify-center">
        <v-btn color="#0278ae" dark fab @click="AddCondition">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ComputeScore from "./ComputeScore";
import _ from "lodash";
import { mapState } from "vuex";
export default {
  props: [
    "rawfixtext",
    "Jump",
    "LastQuestion",
    "fixtext_notmatch",
    "NextQuestion",
  ],
  components: { ComputeScore },
  computed: mapState({
    TextToAdd: "texttoadd",
  }),
  data() {
    return {
      qrbtn: [],
      fixtext: [],
    };
  },
  watch: {
    // TextToAdd: {
    //   handler: function () {
    //     if (this.LastQuestion.type === "quickReply") {
    //       this.fixtext.push({
    //         conditiontext: null,
    //         conditiontype: "fixtext",
    //         fixtext: this.TextToAdd.text,
    //         errorLabel: false,
    //         errorLabelMsg: "",
    //         hascompute: false,
    //         defaultCondition: {
    //           nextQuestionID: this.NextQuestion.questionID,
    //           score: 0,
    //         },
    //         computeCondition: [],
    //       });
    //       this.CheckFixtext();
    //     }
    //   },
    //   deep: true,
    // },
    LastQuestion: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && oldValue) {
          if (newValue.type === "quickReply") {
            this.AddAllButton();
          } else {
            this.qrbtn = [];
            if (this.fixtext.length === 0) {
              this.fixtext.push({
                conditiontext: null,
                conditiontype: "fixtext",
                fixtext: "",
                errorLabel: false,
                errorLabelMsg: "",
                hascompute: false,
                defaultCondition: {
                  nextQuestionID: this.NextQuestion.questionID,
                  score: 0,
                },
                computeCondition: {
                  match: [
                    {
                      nextQuestionID: this.NextQuestion.questionID,
                      operation: "",
                      value: 0,
                      value_from: 0,
                      value_to: 0,
                      score: 0,
                    },
                  ],
                  notmatch: {
                    nextQuestionID: this.NextQuestion.questionID,
                    score: 0,
                  },
                },
              });
            }
            this.CheckFixtext();
          }
        }
      },
    },
    qrbtn: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && oldValue) {
          if (newValue && oldValue) {
            this.$emit("fixtextchange", [...this.qrbtn, ...this.fixtext]);
          }
        }
      },
    },
    fixtext: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && oldValue) {
          this.$emit("fixtextchange", [...this.qrbtn, ...this.fixtext]);
        }
      },
    },
  },
  created() {
    this.fixtext = this.rawfixtext;
    if (this.LastQuestion.type === "quickReply") {
      this.AddAllButton();
    }
  },
  methods: {
    SpaceNotAllow(event, text) {
      if (text[text.length - 1] === " " && event.key === " ") {
        event.preventDefault();
      }
    },
    TrimText(index) {
      let buttonname = this.fixtext[index];
      buttonname.fixtext = buttonname.fixtext.trim().replace(/\s\s+/g, " ");
      this.CheckFixtext();
    },
    RestoreCond(tempfixtext, lastqType) {
      this.$nextTick(() => {
        this.qrbtn = [];
        this.fixtext = [];
        this.fixtext = tempfixtext;
        if (lastqType === "quickReply") {
          this.AddAllButton();
        }
      });
    },
    DisableEdit(text) {
      return !!this.qrbtn.find((fixtext) => fixtext.fixtext === text);
    },
    AddAllButton() {
      if (this.LastQuestion.type === "quickReply") {
        if (this.fixtext.length === 1) {
          if (!this.fixtext[0].fixtext) {
            this.fixtext.pop();
          }
        }
        let tempdata = JSON.parse(JSON.stringify(this.qrbtn));
        let tempqr = [];
        this.LastQuestion.buttons.map((qr) => {
          if (qr.type === "text") {
            let existButton = tempdata.find(
              (fixtext) => fixtext.fixtext === qr.text
            );
            if (!existButton) {
              let samecustom = this.fixtext.find(
                (fixtext) => fixtext.fixtext === qr.text
              );
              if (samecustom) {
                tempqr.push(samecustom);
                this.fixtext.splice(this.fixtext.indexOf(samecustom), 1);
              } else {
                tempqr.push({
                  conditiontext: null,
                  conditiontype: "fixtext",
                  fixtext: qr.text,
                  errorLabel: false,
                  errorLabelMsg: "",
                  hascompute: false,
                  defaultCondition: {
                    nextQuestionID: this.NextQuestion.questionID,
                    score: 0,
                  },
                  computeCondition: {
                    match: [
                      {
                        nextQuestionID: this.NextQuestion.questionID,
                        operation: "",
                        value: 0,
                        value_from: 0,
                        value_to: 0,
                        score: 0,
                      },
                    ],
                    notmatch: {
                      nextQuestionID: this.NextQuestion.questionID,
                      score: 0,
                    },
                  },
                });
              }
            } else {
              tempqr.push(existButton);
            }
          }
        });
        this.qrbtn = tempqr;
        this.CheckFixtext();
      }
    },
    AddCondition() {
      this.fixtext.push({
        conditiontext: null,
        conditiontype: "fixtext",
        fixtext: "",
        errorLabel: false,
        errorLabelMsg: "",
        hascompute: false,
        defaultCondition: {
          nextQuestionID: this.NextQuestion.questionID,
          score: 0,
        },
        computeCondition: {
          match: [
            {
              nextQuestionID: this.NextQuestion.questionID,
              operation: "",
              value: 0,
              value_from: 0,
              value_to: 0,
              score: 0,
            },
          ],
          notmatch: {
            nextQuestionID: this.NextQuestion.questionID,
            score: 0,
          },
        },
      });
    },
    CheckFixtext() {
      let combine = [...this.qrbtn, ...this.fixtext];
      for (const index in combine) {
        let buttonname = combine[index];
        buttonname.fixtext = buttonname.fixtext.trim().replace(/\s\s+/g, " ");
      }
      combine.map((item) => {
        item.errorLabel = false;
        item.errorLabelMsg = "";
      });
      const counts = _.countBy(combine, "fixtext");
      let dup = _.filter(combine, (x) => counts[x.fixtext] > 1);
      if (dup.length > 1) {
        dup.map((item) => {
          if (item.fixtext) {
            item.errorLabel = true;
            item.errorLabelMsg = "ชื่อ fixed text นี้มีอยู่ใน list ของคุณแล้ว";
          }
        });
      }
    },
    CheckFixtextType: _.debounce(function () {
      let combine = [...this.qrbtn, ...this.fixtext];
      // let buttonname = this.fixtext[index];
      // buttonname.fixtext = buttonname.fixtext.trim().replace(/\s\s+/g, " ");
      combine.map((item) => {
        item.errorLabel = false;
        item.errorLabelMsg = "";
      });
      const counts = _.countBy(combine, "fixtext");
      let dup = _.filter(combine, (x) => counts[x.fixtext] > 1);
      if (dup.length > 1) {
        dup.map((item) => {
          if (item.fixtext) {
            item.errorLabel = true;
            item.errorLabelMsg = "ชื่อ fixed text นี้มีอยู่ใน list ของคุณแล้ว";
          }
        });
      }
    }, 0),
  },
};
</script>

<style lang="scss" scoped></style>
